import Thunk from './';
import { Data } from 'src/interfaces/general';
import classTopicContentActions from 'src/store/model/class_topic_content';
import { fetchClassById } from 'src/thunks/classes';
import history from 'src/libs/history';

const topic_content = new Thunk('class_topic_contents');

export type TopicContentPayload = Partial<Model.ClassTopicContents>;

export const fetchTopicContent = topic_content.fetch<
  Data<Model.ClassTopicContents[]>,
  SearchParams.ClassTopicContent
>({
  onSuccess: ({ dispatch, data }) => {
    dispatch(classTopicContentActions.updateEntities(data.data));
  },
});

export const fetchTopicContentById = topic_content.fetchOne<
  Data<Model.ClassTopicContents>
>({
  onSuccess: ({ dispatch, data }) => {
    dispatch(classTopicContentActions.updateEntity(data.data));
  },
  onError: ({ error, args }) => {
    history.push('/');
  },
});

export const updateTopicContent = topic_content.update<
  Data<Model.ClassTopicContents>,
  TopicContentPayload
>({
  onSuccess: ({ dispatch, data }) => {
    dispatch(classTopicContentActions.updateEntity(data.data));
  },
});

export const fetchResources = topic_content.fetchResources<
  void,
  { class_id: string; class_topic_content_id: string }
>(
  'class_topic_content',
  async ({ class_id, class_topic_content_id }, { dispatch }) => {
    await Promise.all([
      dispatch(fetchClassById({ id: class_id })),
      dispatch(fetchTopicContentById({ id: class_topic_content_id })),
    ]);
  },
);
